import { LayoutView } from "../../commons/button/ToggleLayoutViewButtonGroup.js";

// The views with an `items/:itemId` route, under the path segment that holds it —
// the tree view's is `edit`, where its own index route resolves for an editor.
const ITEM_ROUTE_SEGMENTS: Partial<Record<LayoutView, string>> = {
  tree: "edit",
  calculation: "calculation",
  grid: "grid",
  "3d": "3d",
  wizard: "wizard",
};

export function getQuoteLayoutPath(
  pathToDoc: string,
  view: LayoutView,
  selectedItemId: string | null
): string {
  const itemRouteSegment = ITEM_ROUTE_SEGMENTS[view];

  if (selectedItemId && itemRouteSegment) {
    return `${pathToDoc}/${itemRouteSegment}/items/${selectedItemId}`;
  }

  return view === "tree" ? pathToDoc : `${pathToDoc}/${view}`;
}
